'use strict';

$(document).ready(function () {
        let $searchPlace = $('.search-place');
        let $searchBox = $searchPlace.find('input');
        let $mapWrapper = $('.section-interactive-map');
        let $resetInputButton = $searchPlace.find(".icon");
        let lastOpenedInfoWindow = null;

        //reset input text
        $resetInputButton.on('click', function () {
            $($searchBox).val('');
        });

        if ($mapWrapper.length === 0) {
            return;
        }

        function generateMarker(template, title, position, map, company) {
            let image;

            switch(company) {
                case 'E.ON':
                    image = '../public/images/icons/place-eon.png';
                break;
                default:
                    image = '../public/images/icons/place-point.png';
            }

            let marker = new google.maps.Marker({
                position: position,
                map: map,
                title: title,
                icon: image,
                company: company,
            });

            var infowindow = new google.maps.InfoWindow({
                disableAutoPan: true,
                content: template,
            });  

            marker.addListener('click', function () {
                if (lastOpenedInfoWindow) {
                    lastOpenedInfoWindow.close();
                }

                lastOpenedInfoWindow = infowindow;
                infowindow.open(map, marker);
                map.panTo(position)
                map.panBy(0, -300);
            });

        }

        function initSearchPlace() {
            searchBox.addListener('places_changed', function () {
                let places = searchBox.getPlaces();

                if (places.length === 0) {
                    return;
                }

                let userBounds = new google.maps.LatLngBounds();

                places.forEach(function(place) {
                    if (!place.geometry) {
                        console.log('Returned place contains no geometry');
                        return;
                    }

                    if (place.geometry.viewport) {
                        // Only geocodes have viewport.
                        userBounds.union(place.geometry.viewport);
                    } else {
                        userBounds.extend(place.geometry.location);
                    }
                });
                map.fitBounds(userBounds);
            });
        }

        //============
        //====MAIN====
        //============

        let czechCoordinates = {
            lat: 49.7983576,
            lng: 14.3540118
        };

        let map = new google.maps.Map(document.getElementById('map'), {
            zoom: 8,
            center: czechCoordinates,
            scrollwheel: false
        });

        let searchBox = new google.maps.places.SearchBox($searchBox[0]);

        if (markers.length === 0) {
            return;
        }

        map.addListener('bounds_changed', function() {
            searchBox.setBounds(map.getBounds());
        });

        $.each(markers, function (index, item) {
            generateMarker(item.template, item.title, {lat: parseFloat(item.lat), lng: parseFloat(item.lng)}, map, item.company);
        });

        google.maps.event.addListener(map, 'click', function () {
            map.setOptions({
                draggable: true,
                scrollwheel: true
            })
        });

        google.maps.event.addListener(map, 'tilesloaded', function () {
            let loading = $('#loading-screen');
            loading.fadeOut(800);
        });

        google.maps.event.addDomListener(window, 'load', initSearchPlace);
    });



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/chargingStationMap.js